module.exports = __webpack_public_path__ + "img/passportNumber.3e89b351.svg";